import "chart.js/auto";
import {Bar} from "react-chartjs-2";
import {useAppSelector} from "hooks";
import {BarChart2} from "react-feather";
import {Column, Header} from "components";
import {useTheme} from "styled-components";

interface ApprovedLoansProps {}

export const ApprovedLoans: React.FC<ApprovedLoansProps> = () => {
  const {charts} = useAppSelector("home");
  const {finanzasChart} = charts;
  const {black, isDark, black01, white01, primary} = useTheme();

  return (
    <Column>
      <Header icon={BarChart2} children="Créditos Aprobados" />
      <Bar
        style={{maxHeight: 350}}
        options={{
          responsive: true,
          scales: {
            y: {grid: {color: isDark ? white01 : black01}},
            x: {grid: {color: isDark ? white01 : black01}},
          },
        }}
        data={{
          labels: finanzasChart.map(({fecha}) => fecha),
          datasets: [
            {
              borderWidth: 1,
              label: "Total aprobado",
              backgroundColor: isDark ? primary : black,
              data: finanzasChart.map(({monto}) => Number(monto)),
            },
          ],
        }}
      />
    </Column>
  );
};
